package com.hyperether.goodjob.scenes.jobs.components

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.navigation.JobDetails
import kotlinx.datetime.LocalDate

@Composable
fun JobsList(
    sites: Map<String, Site>,
    jobs: List<Map.Entry<Comparable<LocalDate>, List<Job>>>,
    selectedJobs: MutableList<Job>,
    isInEditMode: Boolean,
    navHostController: NavHostController
) {

    LazyColumn(
        modifier = Modifier.fillMaxSize().padding(start = Dp(8f), end = Dp(16f))
    ) {
        if (jobs.isNotEmpty()) {
            jobs.forEach { (date, jobsForDate) ->
                items(jobsForDate.takeIf { it.isNotEmpty() } ?: emptyList()) { job ->
                    JobsItem(
                        sites[job.contactSiteId],
                        job = job,
                        isInEditMode = isInEditMode,
                        selectedJobs,
                        onJobSelected = { selectedJob, isSelected ->
                            if (isSelected) {
                                selectedJobs.add(selectedJob)
                            } else {
                                selectedJobs.remove(selectedJob)
                            }
                        },
                        onItemClick = {
                            navHostController.navigate(JobDetails(job.id!!))
                        },
                    )
                }
            }
        }
    }
}